import React from 'react';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import ollieWordmark from '../../images/Homepage/ollie-logo-plum.svg';
import { FooterColumn, SocialColumn, ConnectColumn } from './FooterColumn';
import { BottomLink } from './FooterLink';
import {
  StyledFooter,
  Paragraph,
  FooterColumns,
  ConstrainedContainer,
  LeftAlignedLinks,
  LegalBlurb,
  FooterDivider,
  FooterBottom,
  CopyrightText,
  FooterWordmark,
  CroppedWordmark,
  ColumnDivider,
} from './styles.js';

export const Footer = ({
  message,
  copyright,
  columnLinks,
  bottomLinks,
  variant,
  isAccount = false,
  backgroundColor = 'hero.deepPlum',
  connectColumn = null,
  textLegalBlurb = null,
  showBottomLogo = true,
}) => {
  const resolvedCopyright = interpolate(copyright, {
    year: new Date().getFullYear(),
  });
  return (
    <StyledFooter $backgroundColor={backgroundColor}>
      <ConstrainedContainer>
        {variant === 'full' && (
          <FooterColumns>
            {columnLinks.map(
              ({ title, links, content, businessHours, hideIfAccount }) =>
                hideIfAccount && isAccount ? null : (
                  <FooterColumn
                    key={title}
                    links={links}
                    businessHours={businessHours}
                    title={title}
                    content={content}
                  />
                ),
            )}
            {connectColumn && connectColumn.socialIcons?.length > 0 ? (
              <>
                <ColumnDivider />
                <ConnectColumn {...connectColumn} />
              </>
            ) : (
              <>
                <ColumnDivider />
                <SocialColumn />
              </>
            )}
          </FooterColumns>
        )}
        <FooterDivider />
        <FooterBottom>
          <CopyrightText>{resolvedCopyright}</CopyrightText>
          <LeftAlignedLinks>
            {bottomLinks.map(({ path, text }, index) => (
              <BottomLink href={path} text={text} index={index} key={path} />
            ))}
          </LeftAlignedLinks>
        </FooterBottom>
        {textLegalBlurb && <LegalBlurb>{textLegalBlurb}</LegalBlurb>}
        <Paragraph>{message}</Paragraph>
        {showBottomLogo && (
          <FooterWordmark>
            <CroppedWordmark>
              <img src={ollieWordmark.src} alt="Ollie" />
            </CroppedWordmark>
          </FooterWordmark>
        )}
      </ConstrainedContainer>
    </StyledFooter>
  );
};

Footer.displayName = 'Footer';

Footer.propTypes = {
  copyright: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  columnLinks: PropTypes.arrayOf(PropTypes.object),
  bottomLinks: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.oneOf(['simplified', 'full']).isRequired,
  isAccount: PropTypes.bool,
  backgroundColor: PropTypes.string,
  connectColumn: PropTypes.object,
  textLegalBlurb: PropTypes.node,
  showBottomLogo: PropTypes.bool,
};
